import React from 'react';

/** REP-V2 dark tokens — pages satellite stock (inventaire, historique, form, import). */
export const STOCK_PANEL = 'rounded-xl border border-white/10 bg-[#151820]';

export const STOCK_BTN_PRIMARY =
  'inline-flex items-center justify-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg bg-red-600 hover:bg-red-500 text-white font-bold text-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

export const STOCK_BTN_SECONDARY =
  'inline-flex items-center justify-center gap-2 px-4 py-2.5 min-h-[44px] rounded-lg border border-white/10 bg-black/20 text-gray-300 hover:border-white/20 hover:text-white font-semibold text-sm transition-colors disabled:opacity-40';

export const STOCK_BTN_ICON =
  'p-2 rounded-lg border border-white/10 bg-black/20 text-gray-400 hover:text-white hover:border-white/20 transition-colors';

export const STOCK_INNER_TAB_ACTIVE = 'bg-red-600 text-white shadow-sm';
export const STOCK_INNER_TAB_INACTIVE = 'text-gray-400 hover:text-white hover:bg-white/5';

export const STOCK_FILTER_ACTIVE = 'bg-red-600 text-white font-semibold';
export const STOCK_FILTER_INACTIVE = 'border border-white/10 bg-black/20 text-gray-400 hover:border-white/20 hover:text-white font-semibold';

export const STOCK_KPI_CARD = `${STOCK_PANEL} p-3 sm:p-4 text-center`;

export const StockFormSection = ({ title, icon: Icon, children, className = '' }) => (
  <div className={`${STOCK_PANEL} p-4 sm:p-5 ${className}`}>
    <div className="flex items-center gap-2 mb-4 pb-3 border-b border-white/10">
      {Icon && <Icon className="w-4 h-4 text-red-400 shrink-0" />}
      <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wide">{title}</h3>
    </div>
    {children}
  </div>
);
